import * as wgxpath from 'wicked-good-xpath';

export default function () {
  wgxpath.install();
}
